module.exports = __webpack_public_path__ + "img/AI (4).49b62d8a.png";